import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { BusinessMaps } from '../components/BusinessMaps';
import { ArrowLeftIcon, MapIcon } from 'lucide-react';
export function BusinessMapPage() {
  const {
    language
  } = useLanguage();
  const isEs = language === 'ES';
  return <div className="min-h-screen bg-gray-50 font-nunito" data-id="element-2315">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm" data-id="element-2316">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between" data-id="element-2317">
          <div className="flex items-center gap-4" data-id="element-2318">
            <button onClick={() => {
            window.location.hash = '';
            window.history.back();
          }} className="inline-flex items-center gap-2 text-haa-navy hover:text-haa-blue transition-colors font-nunito font-bold text-sm" data-id="element-2319">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-2320" />
              {isEs ? 'Volver al Inicio' : 'Back to Home'}
            </button>
          </div>
          <div className="flex items-center gap-3" data-id="element-2321">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-haa-navy to-haa-blue flex items-center justify-center shadow-md" data-id="element-2322">
              <MapIcon className="w-5 h-5 text-white" data-id="element-2323" />
            </div>
            <div data-id="element-2324">
              <h1 className="font-bebas text-2xl sm:text-3xl text-haa-navy tracking-wider leading-none" data-id="element-2325">
                {isEs ? 'Mapa de Empresas Hondureño-Americanas' : 'Honduran-American Business Map'}
              </h1>
              <p className="font-nunito text-xs text-gray-500 mt-0.5" data-id="element-2326">
                {isEs ? 'Honduran-American Association' : 'Honduran-American Association'}
              </p>
            </div>
          </div>
          <div className="w-[120px]" data-id="element-2327" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2328">
        <BusinessMaps data-id="element-2329" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-haa-navy py-6 mt-12" data-id="element-2330">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2331">
          <p className="font-nunito text-sm text-white/60" data-id="element-2332">
            © {new Date().getFullYear()} Honduran-American Association
          </p>
        </div>
      </footer>
    </div>;
}